import { OnboardingFormActions } from '../../../enums'
import { AddCompanyAction } from '../../../types/actions'

export const addCompany = (): AddCompanyAction => ({
  type: OnboardingFormActions.ADD_COMPANY
})
